import React from 'react';
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';

// Components
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import Icon from '../../../../components/icons/Icon';
import { useActiveTableCallback, useActiveTableSelector } from '../../bridge/store/hotTableStoreHooks';

// Utils
import { isSelectingMultipleSelections } from '../../bridge/utils/selectionUtils/tableSelectionPredicateUtils';
import { addHotTableColsRight } from '../utils/hotInstanceUtils/grid/hotTableGridOperationsUtils';

// Selectors
import { selectActiveTableCellSelection } from '../../bridge/store/selectors/activeHotTableCellSelectionSelectors';

type AddColumnToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const AddColumnTool: React.FC<AddColumnToolProps> = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const onClick = useActiveTableCallback((activeTable) => addHotTableColsRight(activeTable.instance, undefined), []);

    return (
        <div className="AddColumnTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

export default AddColumnTool;
